import "./Table.scss";

function Table({ children }) {
    return (
        <div className="table__container">
            <div className="table__inner-wrapper">
                <table className="table__table">
                    {children}
                </table>
            </div>
        </div>
    );
}

function THead({ children, className = "", ...rest }) {
    return (
        <thead {...rest} className={`table__thead ${className}`}>
            {children}
        </thead>
    );
}

function TR({ children, ...rest }) {
    return (
        <tr {...rest} className="table__tr">
            {children}
        </tr>
    );
}

function TH({ children, className = "", listItems = [], ...rest }) {
    const items = listItems.length > 0 ? listItems : [children];

    return items.map((item, index) => {
        const isFirst = index === 0;
        const isLast = index === items.length - 1;

        const thClass = isFirst
            ? "table__th table__th--first"
            : isLast
            ? "table__th table__th--last"
            : "table__th";

        const content =
            typeof item === "object" && item.sr && item.item
                ? <span className="table__sr-only">{item.item}</span>
                : item;

        return (
            <th key={`th-${index}`} scope="col" className={`${thClass} ${className}`} {...rest}>
                {content}
            </th>
        );
    });
}

function TBody({ children, className = "", ...rest }) {
    return (
        <tbody {...rest} className={`table__tbody ${className}`}>
            {children}
        </tbody>
    );
}

function TD({ children, className = "", listItems = [], headers = [], ...rest }) {
    const items = listItems.length > 0 ? listItems : [children];

    return items.map((item, index) => {
        const isFirst = index === 0;
        const isLast = index === items.length - 1;

        const tdClass = isFirst
            ? "table__td table__td--first"
            : isLast
            ? "table__td table__td--last"
            : "table__td";

        const label = headers[index] || "";

        const content =
            typeof item === "object" && item.sr && item.item ? (
                <span className="table__sr-only">{item.item}</span>
            ) : (
                <>
                    <span className="table__mobile-label">{label}</span>
                    {item}
                </>
            );

        return (
            <td key={`td-${index}`} className={`${tdClass} ${className}`} {...rest}>
                {content}
            </td>
        );
    });
}

Table.Header = THead;
Table.Row = TR;
Table.HeaderCell = TH;
Table.Body = TBody;
Table.Cell = TD;

export default Table;